import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './MobileHeader.css';
import './Header.css';

// 需求澄清：
// 1. 你希望將右上角購物車 icon 連結到 /cart route，讓使用者點擊後可以進入購物車頁面。
// 2. 目前購物車 icon 僅為 <span>，沒有包裹 <Link>，因此無法跳轉。
// 3. 你希望保留現有的 sidebar、下拉選單等互動行為。
// 4. 目前 isMobile 狀態未被使用，會造成 eslint no-unused-vars 警告，需移除。

function MobileHeader({
  sidebarOpen,
  toggleSidebar,
  sidebarRef,
  seriesDropdownOpen,
  characterDropdownOpen,
  systemActivityDropdownOpen,
  toggleSeriesDropdown,
  toggleCharacterDropdown,
  toggleSystemActivityDropdown,
  seriesOptions,
  characterOptions,
  systemActivityOptions,
  convertToPinyin,
  seriesDropdownRef,
  characterDropdownRef,
  systemActivityDropdownRef,
  setSystemActivityDropdownOpen,
  setSeriesDropdownOpen,
  setCharacterDropdownOpen
}) {
  // 移除未使用的 isMobile 狀態
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const header = document.querySelector('.mobile-header-row.fixed-mobile-header');
      const setHeaderHeight = () => {
        if (header) {
          const height = header.offsetHeight + 5; // 多加 5px
          document.documentElement.style.setProperty('--mobile-header-height', height + 'px');
        }
      };
      setHeaderHeight();
      window.addEventListener('resize', setHeaderHeight);
      return () => window.removeEventListener('resize', setHeaderHeight);
    }
  }, []);

  // 處理側邊欄選項點擊事件
  const handleSidebarOptionClick = () => {
    if (typeof toggleSidebar === 'function') {
      toggleSidebar();
    }
  };

  return (
    <div className={`App mobile${sidebarOpen ? ' sidebar-open' : ''}`}>
      {/* 佔位用的 header-fixed-wrapper */}
      {/* 固定顯示的 header */}
      <div className="mobile-header-row fixed-mobile-header">
        {/* 左側 Sidebar（漢堡選單） */}
        <div className="menu-toggle">
          <button id="menu-toggle" onClick={toggleSidebar} className="menu-button">
            <img src="/sidebar_menu.webp" alt="選單" className="menu-icon" />
          </button>
        </div>
        {/* 中間 LOGO */}
        <Link to="/" className="title-link mobile-logo-center">
          <img src="/title.webp" alt="ちいかわ開心代購" className="title-logo" />
        </Link>
        {/* 右側購物車，改為可點擊連結到 /cart */}
        <Link to="/cart" className="cart-navbar-icon" aria-label="購物車">
          {/* 願望清單（心型）icon，顏色與主題一致 */}
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 21s-5.05-4.35-7.07-6.36C2.07 12.14 2 9.28 4.11 7.21c2.11-2.07 5.53-1.7 7.39.62 1.86-2.32 5.28-2.69 7.39-.62 2.11 2.07 2.04 4.93-.82 7.43C17.05 16.65 12 21 12 21z"
              fill="#ff9800"
              stroke="#ff9800"
              strokeWidth="1"
            />
          </svg>
        </Link>
        {sidebarOpen && (
          <>
            <div className="sidebar-overlay" onClick={toggleSidebar}></div>
            <div className="sidebar" ref={sidebarRef}>
              <ul className="sidebar-list">
                <li>
                  <Link to="/order" className="sidebar-link hide-order-query" onClick={handleSidebarOptionClick}>訂單查詢</Link>
                </li>
                <li>
                  <Link to="/stock?page=1" className="sidebar-link" onClick={handleSidebarOptionClick}>品項瀏覽</Link>
                </li>
                <li className="sidebar-dropdown">
                  <button 
                    className={`dropdown-toggle${systemActivityDropdownOpen ? ' open' : ''}`} 
                    onClick={toggleSystemActivityDropdown}
                  >
                    專題/活動
                    <span className="arrow">{systemActivityDropdownOpen ? '▼' : '◀'}</span>
                  </button>
                  <ul className={`sidebar-dropdown-menu${systemActivityDropdownOpen ? ' show' : ''}`}>
                    {systemActivityOptions.map((option, index) => (
                      <li key={index}>
                        <Link
                          to={`/activity/${encodeURIComponent(option)}`}
                          className="dropdown-item"
                          onClick={() => {
                            setSystemActivityDropdownOpen(false);
                            handleSidebarOptionClick();
                          }}
                        >
                          {option}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="sidebar-dropdown">
                  <button
                    className={`dropdown-toggle${seriesDropdownOpen ? ' open' : ''}`}
                    onClick={toggleSeriesDropdown}
                  >
                    系列查詢
                    <span className="arrow">{seriesDropdownOpen ? '▼' : '◀'}</span>
                  </button>
                  <ul className={`sidebar-dropdown-menu${seriesDropdownOpen ? ' show' : ''}`}>
                    {seriesOptions.map((option, index) => (
                      <li key={index}>
                        <Link
                          to={`/series/${convertToPinyin(option)}`}
                          className="dropdown-item"
                          onClick={() => {
                            setSeriesDropdownOpen(false);
                            handleSidebarOptionClick();
                          }}
                        >
                          {option}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="sidebar-dropdown">
                  <button 
                    className={`dropdown-toggle${characterDropdownOpen ? ' open' : ''}`} 
                    onClick={toggleCharacterDropdown}
                  >
                    角色查詢
                    <span className="arrow">{characterDropdownOpen ? '▼' : '◀'}</span>
                  </button>
                  <ul className={`sidebar-dropdown-menu${characterDropdownOpen ? ' show' : ''}`}>
                    {Object.entries(characterOptions).map(([key, value]) => (
                      <li key={value}>
                        <Link
                          to={`/products_character/${value}`}
                          className="dropdown-item"
                          onClick={() => {
                            setCharacterDropdownOpen(false);
                            handleSidebarOptionClick();
                          }}
                        >
                          {key}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                
              </ul>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MobileHeader; 